import { shorelineOrientationSchema } from "@shared/wind-classification";

/** Use exactly the same reviewed-evidence contract as wind alert evaluation. */
export function WindOrientationNotice({ orientation, directionFilter, showSpeedOnly = false }: {
  orientation: unknown;
  directionFilter?: string;
  showSpeedOnly?: boolean;
}) {
  if (shorelineOrientationSchema.safeParse(orientation).success) return null;
  const filtered = !!directionFilter && directionFilter !== "any";
  if (!filtered && !showSpeedOnly) return null;

  return (
    <p role="status" className="mt-2 text-[11px] leading-relaxed text-amber-400">
      Wind direction unavailable: this spot’s shoreline orientation has not been reviewed.
      {" "}{filtered
        ? "This direction-filtered alert cannot trigger until it is reviewed. Your direction filter is kept; choose Any direction to use wind speed only."
        : "Onshore, offshore, and sideshore filters cannot be evaluated yet. Any direction alerts still work using wind speed only."}
    </p>
  );
}
